export default __webpack_public_path__ + "static/video-9-1c3e11740b607a77a564c227806d2c54.png";